<!-- 医院库Beta -->
<template>
  <div class="hospital-beta">
    <div v-show="!showHospitalDetail" style="margin-top: 24px">
      <!-- 头部筛选 -->
      <div class="filter-box">
        <div class="left">
          <span>地区:</span>
          <province-city-area @provinceCityAreaEmit="provinceCityAreaEmit" />
          <span style="padding-left: 10px">关键字:</span>
          <div class="filterHospitalTitle" style="display: inline-block">
            <el-input
              v-model="queryParams.hospital_name"
              :clearable="true"
              placeholder="例: 医院名称"
              @keydown.enter.native="onSubmit"
            />
          </div>
        </div>
        <div class="right">
          <el-button class="filter-button" type="primary" @click="onSubmit">筛选</el-button>
        </div>
      </div>
      <!-- 列表 -->
      <div class="table-list">
        <el-table
          v-loading="tableLoading"
          :data="tableData"
          :header-cell-style="{ background: '#d8d8d81a', color: '#303133', fontWeight: '100' }"
        >
          <template slot="empty">
            <div class="table-noData">
              <img
                class="table-noData-img"
                src="https://baike-med-1256891581.file.myqcloud.com/2021034/c03485a0-8608-11eb-947c-032fa08bea6e_0.png"
              />
              <div class="table-noData-word">暂无相关内容</div>
            </div>
          </template>
          <el-table-column prop="hospital_name" label="医院名" min-width="35%"></el-table-column>
          <el-table-column prop="province" label="所属省" min-width="15%"></el-table-column>
          <el-table-column prop="city" label="所属市" min-width="15%"></el-table-column>
          <el-table-column prop="level" label="级别" min-width="15%"></el-table-column>
          <el-table-column prop="doctor_num" label="医生数量" min-width="15%"></el-table-column>
          <el-table-column label="操作" min-width="20%">
            <template slot-scope="scope">
              <el-button type="text" @click="operationEmit(scope.row)" style="font-size: 16px">
                查看详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.page_index"
          :page-size="queryParams.page_size"
          :page-sizes="g_pageSizesConfig"
          layout="total,sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ProvinceCityArea from '@/components/province-city-area/province-city-area';
import { queryPagesApi } from '@/api/setUp.js';

export default {
  name: 'HospitalBeta',
  components: {
    ProvinceCityArea,
  },
  props: {},
  data() {
    return {
      tableData: [],
      queryParams: {
        hospital_name: '',
        province: '',
        city: '',
        page_index: 1,
        page_size: 0,
        sort_by: '',
      },
      total: 0,
      tableLoading: false,
      showHospitalDetail: false,
      rowTemp: {}, // 暂存行 如调用HospitalDetail组件需要行数据
    };
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created() {
    this.queryParams.page_size = this.g_pageSizeDefault;
    this.getList();
  },
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  methods: {
    handleSizeChange(val) {
      this.queryParams.page_size = val;
      this.getList();
    },
    handleCurrentChange(page) {
      this.queryParams.page_index = page;
      this.getList();
    },
    getList() {
      this.tableLoading = true;
      queryPagesApi(this.queryParams)
        .then((res) => {
          this.tableData = res.data ? res.data : [];
          this.total = res.total_num;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },

    // 筛选按钮事件
    onSubmit() {
      this.queryParams.page_index = 1;
      this.getList();
    },

    // 省市区回调 {province, city, area}
    provinceCityAreaEmit(e) {
      this.queryParams.province = e.province;
      this.queryParams.city = e.city;
    },

    // 操作行回调事件
    operationEmit(e) {
      this.g_tourl(`/saas/setUp/hospitalManagement/hospitalDetail.html?id=${e.hospital_id}`);
    },
  },
};
</script>
<style lang="scss" scoped>
.hospital-beta {
  .filter-box {
    display: flex;
    justify-content: space-between;
    ::v-deep.el-input__inner {
      padding-right: 30px;
    }
    .filterHospitalTitle {
      ::v-deep .el-input__inner {
        width: 350px;
      }
    }
    .filter-button {
      width: 100px;
      height: 48px;
    }
  }
  .table-list {
    margin-top: 20px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    ::v-deep .el-table__header-wrapper .el-table__header {
      color: #303133;
      background: rgba(216, 216, 216, 0.1);
    }
    ::v-deep .el-table .cell {
      font-size: 16px;
    }
    ::v-deep .el-table__empty-text {
      line-height: 0px;
    }
    .table-noData {
      width: 100%;
      height: 100%;
      text-align: center;

      .table-noData-img {
        width: 240px;
        height: 192px;
        margin-top: 100px;
      }

      .table-noData-word {
        font-size: 16px;
        color: #909399;
        text-align: center;
        margin: 16px 0 65px 0;
        height: 22px;
      }
    }
  }
  .pagination {
    margin-top: 12px;
    float: right;
  }
}
</style>
